import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { TabList, Tabs, Tab } from "@similarweb/ui-components";

import { openHooksModalV6 } from "app/services/ModalService";
import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

import { ECategoryLeadersMetricType } from "../category-leaders/CategoryLeaders.types";

import { TABS } from "./consts";
import { isTabLocked, navigateToWebsiteRankingsTab } from "./utils";

interface WebsiteRankingsTabsProps {
    selectedTabId: ECategoryLeadersMetricType;
}

export const WebsiteRankingsTabs = ({ selectedTabId }: WebsiteRankingsTabsProps) => {
    const { params, state } = useCurrentStateAndParams();
    const hasCategory = !!params.category;
    const selectedTabIndex = TABS.findIndex((tab) => tab.id === selectedTabId);

    // Handle URL-based redirection for locked tabs
    useEffect(() => {
        if (
            state.name === "digitalsuite_marketresearch_webmarketanalysis_rankings" &&
            selectedTabId !== ECategoryLeadersMetricType.CategoryLeadersAll &&
            isTabLocked(selectedTabId)
        ) {
            navigateToWebsiteRankingsTab(ECategoryLeadersMetricType.CategoryLeadersAll);
        }
    }, [selectedTabId, state.name]);

    const onSelect = (index: number) => {
        const { id } = TABS[index];

        allTrackers.dispatchTrackEvent("Button", "click", "Industry Analysis Tab", {
            channel: ECategoryLeadersMetricType[id],
        });

        if (isTabLocked(id)) {
            openHooksModalV6("acquisitionLeaders");
            return;
        }

        if (!hasCategory) {
            return;
        }

        navigateToWebsiteRankingsTab(id);
    };

    return (
        <Tabs
            selectedIndex={selectedTabIndex}
            onSelect={onSelect}
        >
            <TabList>
                {TABS.map(({ id, titleKey, isLocked }) => (
                    <Tab
                        key={id}
                        isLocked={isLocked}
                    >
                        {translate(titleKey)}
                    </Tab>
                ))}
            </TabList>
        </Tabs>
    );
};
